export default __webpack_public_path__ + "static/media/drop_down_arrow.9646c4cc.svg";